export enum PriceMode {
  DEFAULT = 'default',
  MIN = 'min',
}
